
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dykmQ", function(module, exports) {

$parcel$export(module.exports, "watchedToLibrary", () => $9dde3fe4d71b29d4$export$d3b7ef596551f202);
$parcel$export(module.exports, "queueToLibrary", () => $9dde3fe4d71b29d4$export$a1343c6c4fc01273);

var $40lI0 = parcelRequire("40lI0");
function $9dde3fe4d71b29d4$export$d3b7ef596551f202() {
    const gallery = document.querySelector("#movie-items-lib");
    console.log(gallery);
    gallery.innerHTML = "";
    if (JSON.parse(localStorage.getItem("movies-watched"))) try {
        const array = JSON.parse(localStorage.getItem("movies-watched")) || [];
        const markup = array.map(({ poster_path: poster_path, title: title, vote_average: vote_average, release_date: release_date, genres: genres, id: id })=>{
            const genreArray = [];
            for (const genre of genres)genreArray.push(genre.name);
            return `
    <div class="movie-card-template" data-modal-open-window>
    <h2 id="movie-id" class="is-hidden">${id}</h2>
    <a class="movie-image">
    <img class="movie-image-detail" src="https://image.tmdb.org/t/p/w500${poster_path}?api_key=a53cba9b0d8796262c7859f0f1e4d0eb" onerror="this.src='https://cdn.pixabay.com/photo/2019/04/24/21/55/cinema-4153289_960_720.jpg';"
    alt="film-poster" />
    </a>
    <div class="movie-info">
    <p class="movie-name">${title}</p>
    <div class="tags-grade-wrap">
    <p class="movie-tags-year">${genreArray.slice(0, 3).join(", ")} | ${release_date.slice(0, 4)}</p>
    <p class="movie-grade">${vote_average.toFixed(1)}</p>
    </div>
    </div>
    </div>`;
        }).join("");
        gallery.insertAdjacentHTML("afterbegin", markup);
    //setTimeout(loaderRemove, 1000);
    } catch (error) {
        console.log(error);
        return [];
    }
    const movieCardTemplate = document.querySelectorAll(".movie-card-template");
    movieCardTemplate.forEach((card)=>{
        card.addEventListener("click", (e)=>{
            (0, $40lI0.openModal)(e);
        });
    });
}
function $9dde3fe4d71b29d4$export$a1343c6c4fc01273() {
    const gallery = document.querySelector("#movie-items-lib");
    console.log(gallery);
    //loaderAdd();
    //const array = JSON.parse(localStorage.getItem('movies-watched')); // parse JSON string to object;
    //console.log(array);
    gallery.innerHTML = "";
    if (JSON.parse(localStorage.getItem("movies-queue"))) try {
        const arrayQueue = JSON.parse(localStorage.getItem("movies-queue")) || [];
        const markupQueue = arrayQueue.map(({ poster_path: poster_path, title: title, vote_average: vote_average, release_date: release_date, genres: genres, id: id })=>{
            const genreArray = [];
            for (const genre of genres)genreArray.push(genre.name);
            return `
    <div class="movie-card-template" data-modal-open-window>
    <h2 id="movie-id" class="is-hidden">${id}</h2>
    <a class="movie-image">
    <img class="movie-image-detail" src="https://image.tmdb.org/t/p/w500${poster_path}?api_key=a53cba9b0d8796262c7859f0f1e4d0eb"
    alt="film-poster" />
    </a>
    <div class="movie-info">
    <p class="movie-name">${title}</p>
    <div class="tags-grade-wrap">
    <p class="movie-tags-year">${genreArray.slice(0, 3).join(", ")} | ${release_date.slice(0, 4)}</p>
    <p class="movie-grade">${vote_average.toFixed(1)}</p>
    </div>
    </div>
    </div>`;
        }).join("");
        gallery.insertAdjacentHTML("afterbegin", markupQueue);
    //setTimeout(loaderRemove, 1000);
    } catch (error) {
        console.log(error);
        return [];
    }
    const movieCardTemplate = document.querySelectorAll(".movie-card-template");
    movieCardTemplate.forEach((card)=>{
        card.addEventListener("click", (e)=>{
            (0, $40lI0.openModal)(e);
        });
    });
}

});


parcelRequire("dykmQ");

//# sourceMappingURL=library.8e3af8dc.js.map
